/** Sidebar groups, verbatim from the console mockup's `navGroups`. */
export const NAV_GROUPS: { group: string; items: { to: string; label: string }[] }[] = [
  {
    group: "CORE",
    items: [
      { to: "/dashboard", label: "dashboard" },
      { to: "/namespaces", label: "namespaces" },
      { to: "/query", label: "query" },
      { to: "/multi-query", label: "multi-query" },
      { to: "/documents", label: "documents" },
    ],
  },
  {
    group: "PIPELINE",
    items: [
      { to: "/operations", label: "operations" },
      { to: "/compaction", label: "compaction · gc" },
      { to: "/analytics", label: "analytics" },
    ],
  },
  {
    group: "CODE SEARCH",
    items: [
      { to: "/repos", label: "repos" },
      { to: "/jobs", label: "jobs" },
    ],
  },
  {
    group: "ACCESS",
    items: [
      { to: "/keys", label: "api keys" },
      { to: "/embedders", label: "embedders" },
      { to: "/workspace", label: "workspace" },
      { to: "/superadmin", label: "super-admin" },
    ],
  },
  {
    group: "ACCOUNT",
    items: [
      { to: "/settings", label: "settings" },
      { to: "/billing", label: "billing" },
    ],
  },
];

/** Command-palette entries, verbatim from the mockup's `paletteCmds`. */
export const PALETTE_COMMANDS: { label: string; key: string; to: string }[] = [
  { label: "Go to dashboard", key: "⏎", to: "/dashboard" },
  { label: "Create namespace", key: "c", to: "/namespaces/new" },
  { label: "Run a query", key: "q", to: "/query" },
  { label: "Multi-namespace query", key: "m", to: "/multi-query" },
  { label: "View operations pipeline", key: "o", to: "/operations" },
  { label: "Manage API keys", key: "k", to: "/keys" },
  { label: "View trash / pending deletions", key: "t", to: "/compaction" },
  { label: "Super-admin console", key: "a", to: "/superadmin" },
];
